import { render } from "./FixMenu.vue?vue&type=template&id=6ad904f2"
import script from "./FixMenu.vue?vue&type=script&lang=js"
export * from "./FixMenu.vue?vue&type=script&lang=js"

import "./FixMenu.vue?vue&type=style&index=0&id=6ad904f2&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vuemasi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__